import React, { useState } from 'react';
import { PARTNER_SERVICES } from '../../constants/EntityName';
import AssignPackageModal from './AssignPackageModal';
import AbstractLanding from '../Entity/AbstractLanding';
import { partnerServicesFormData } from '../../datamodels/PartnerServices';
import { getTableHeaders } from '../../utils/forms/FormDataModel';

const PartnerServices = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editData, setEditData] = useState<any>(null);
  const [refreshData, setRefreshData] = useState<boolean>(false);
  const [generatedId, setGeneratedId] = useState<number | null>(null);

  const tableHeaders: any = getTableHeaders(partnerServicesFormData);
  const headerName = 'Partner Service Management';
  const addName = 'Partner Service';

  const handleAction = async (record?: any) => {
    if (record && record.id) {
      setEditData(record);
      setGeneratedId(null);
      setIsModalVisible(true);
    } else {
      setEditData(null);
      // Generated ID logic is tricky to port directly without async/await in the trigger
      // But we can just set modal visible and let the user fill it or handle it inside modal if needed
      // For now, let's keep it simple or move the ID generation logic inside the modal if possible,
      // or we accept we might not pre-fill ID here unless we fetch it.
      // But wait, the original code fetched the ID.
      // Let's rely on the backend or manual input for now, or just pass null and let modal handle it.
      // The modal uses `generatedId`.
      // We can fetch it here before opening if we want, but since `onAdd` is synchronous in AbstractLanding interface (mostly),
      // we should probably just open it.
      setIsModalVisible(true);
    }
  };

  const handleSuccess = () => {
    setIsModalVisible(false);
    setEditData(null);
    setRefreshData(prev => !prev);
  };

  const handleDelete = async (id: string) => {
    setRefreshData(prev => !prev);
  };

  return (
    <div style={{ padding: '0px', marginTop: '30px' }}>
      <AbstractLanding
        headerName={headerName}
        entityName={PARTNER_SERVICES}
        tableHeaders={tableHeaders}
        onAdd={record => handleAction(record)}
        refreshData={refreshData}
        addName="Create Partner Service"
        hideAddPrefix={true}
      />

      <AssignPackageModal
        visible={isModalVisible}
        onCancel={() => {
          setIsModalVisible(false);
          setEditData(null);
        }}
        onSuccess={handleSuccess}
        initialData={editData}
        onDelete={handleDelete} // AssignPackageModal handles the API call, we just refresh
        generatedId={generatedId}
      />
    </div>
  );
};

export default PartnerServices;
